<template>
  <div>

    <validation-observer ref="form">

      <b-form @submit.prevent="save">

        <div class="vx-row">
          <div class="vx-col sm:w-3/12 w-full mb-2">
            <b-form-group
              label="Tipo Email"
              label-for="email_type_id">
              <validation-provider
                #default="{ errors }"
                :name="$t('email_.type')"
                rules="required">
                <v-select id="email_type_id" v-model="emailType" :options="emailTypes" label="name" class="required-select">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <div class="vx-col sm:w-7/12 w-full">
            <b-form-group
              label="Email"
              label-for="email_address">
              <validation-provider
                #default="{ errors }"
                :name="$t('email_.email')"
                rules="required|email">
                <b-form-input
                  type="email"
                  id="email_address"
                  v-model="emailAddress"
                  :state="errors.length > 0 ? false:null"
                  name="email_address"
                  class="required"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <div class="vx-col sm:w-2/12 w-full">
            <div class="vx-col w-full">
              <b-form-checkbox v-model="head" class="mt-6 float-right">{{ $t('email_.email_head') }}</b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col w-full">

            <b-button
              v-if="editMode"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="cancelEdit"
              class="mt-5 float-right">
              Limpar
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :class="['mt-5 float-right', {'mr-2': editMode}]"
              :disabled="!validateForm">
              {{this.editMode ? 'Alterar' : 'Adicionar'}}
            </b-button>
          </div>
        </div>

      </b-form>
    </validation-observer>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="emailList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Tipo</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Principal</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].email_type.name}}</vs-td>
              <vs-td>{{data[indextr].email_address}}</vs-td>
              <vs-td>
                <span v-if="data[indextr].pivot.head">Sim</span>
                <span v-else>Não</span>
              </vs-td>
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="EditIcon"
                    title="Editar"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-warning"
                    @click="edit(data[indextr])"/>
                  <feather-icon
                    icon="Trash2Icon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                  </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'

import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    people_id: {
      type: Number,
      default: null
    },
  },
  data: () => ({
    id: null,
    parentEntity: null,
    emailTypes: [],
    emailType: null,
    emailAddress: null,
    emailList: [],
    head: false,
    editMode: false,
    // validation rules
    required,
    email
  }),
  computed: {
    validateForm() {
      return this.emailType !== null && !this.isEmpty(this.emailAddress)
    }
  },
  watch: {
    emailAddress() {
      this.clearErrors(this.$validator)
    }
  },
  methods: {
    save() {

      this.$refs.form.validate().then(success => {
        if (success) {

          this.clearErrors(this.$refs.form)
          this.$vs.loading()

          const params = {
            people_id: this.people_id,
            email_type_id: this.emailType.id,
            email_address: this.emailAddress,
            head: this.head
          }

          if (this.editMode) {
            params['id'] = this.id
          }

          this.services.emailService.createOrUpdate(params).then(
            data => {
              this.$vs.loading.close()
              this.loadData()
              this.editMode = false
              this.clearFields()
              this.notifySuccess(this.$vs)
            },
            error => {
              this.$vs.loading.close()
              this.showErrors(this.$refs.form, error)
            }
          )
        }
      })
    },
    destroy(email) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(email)
        }
      })
    },
    acceptDestroy(email) {
      this.$vs.loading()
      this.services.emailService
        .destroy({
          id: email.id
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.emailList = this.emailList.filter(element => {
              return element.id !== email.id
            })
            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    edit(email) {
      this.id = email.id
      this.editMode = true
      this.emailType = email.email_type
      this.emailAddress = email.email_address
      this.head = email.pivot.head
    },
    cancelEdit() {
      this.editMode = false
      this.clearFields()
    },
    clearFields() {
      this.emailType = null
      this.emailAddress = null
      this.head = false
    },
    loadData() {
      this.services.emailService.getAllByPeople(this.people_id).then(
        response => {
          this.emailList = Array.from(response)
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    }
  },
  beforeMount() {},
  beforeDestroy() {

  },
  mounted() {
    this.loadData()

    this.services.emailTypeService.all().then(data => {
      this.emailTypes = data
    })
  }
}
</script>
